import React from 'react';

import {
  SearchUserEventsRequestDtoOperationsEnum,
  SearchUserEventsRequestDtoProfilsEnum,
} from 'lib_api/lib/api/gen';

import BaseForm from 'components/BaseForm/BaseForm';
import BaseRangeDatePicker from 'components/BaseForm/BaseRangeDatePicker';
import BaseSelect from 'components/BaseForm/Select/BaseSelect';
import { SupervisionUserEventsFilterFormValues } from 'components/Supervision/SupervisionHeader/types';
import { userEventOperationsMapping } from 'components/Supervision/utils';
import { profileEnumMapping } from 'utils/enumData';

import FormFooter from './FormFooter/FormFooter';

interface SupervisionFilterFormProps {
  filter: Partial<SupervisionUserEventsFilterFormValues>;
  setFilter: (value: Partial<SupervisionUserEventsFilterFormValues>) => void;
}

function SupervisionFilterForm({
  filter,
  setFilter,
}: SupervisionFilterFormProps) {
  const initialFilters = { ...filter };

  const operationsOptions = [
    SearchUserEventsRequestDtoOperationsEnum.DELETE,
    SearchUserEventsRequestDtoOperationsEnum.CREATE,
  ];

  const profilesOptions = [
    SearchUserEventsRequestDtoProfilsEnum.GARDIEN_FOURRIERE,
    SearchUserEventsRequestDtoProfilsEnum.FORCE_DE_L_ORDRE,
    SearchUserEventsRequestDtoProfilsEnum.AUTORITE_FOURRIERE,
  ];

  return (
    <BaseForm
      initialValues={initialFilters}
      onSubmit={() => Promise.resolve()}
      renderButtonAction={() => <FormFooter setFilter={setFilter} />}
      onChange={(
        changed,
        all: Partial<SupervisionUserEventsFilterFormValues>,
      ) => {
        return {
          ...all,
        };
      }}
      inputs={[
        {
          name: 'dateRangeRealisation',
          label: 'Date de réalisation',
          render: () => <BaseRangeDatePicker />,
        },
        {
          name: 'operations',
          label: 'Opérations',
          render: () => (
            <BaseSelect
              options={operationsOptions}
              getOptionValue={option => option.toString()}
              getOptionLabel={options => userEventOperationsMapping[options]}
              mode="multiple"
              allowClear
            />
          ),
        },
        {
          name: 'profils',
          label: 'Profils',
          render: () => (
            <BaseSelect
              options={profilesOptions}
              getOptionValue={option => option.toString()}
              getOptionLabel={options => profileEnumMapping[options].name}
              mode="multiple"
              allowClear
            />
          ),
        },
      ]}
    />
  );
}

export default SupervisionFilterForm;
